import {
  Shape,
  ShapeGeometry,
  Mesh,
  MeshStandardMaterial,
  Vector2,
  Scene,
  BufferAttribute,
  InstancedMesh,
  Texture
} from "three";

import PoolBorders from "./pool_borders";
import AssetManager from "../utils/asset_manager";

class WoodPlanksOutline {
  plankShape: Shape;
  private woodplankMesh: Mesh;
  private poolBorders: PoolBorders;
  outlineSize: number;

  private material: MeshStandardMaterial;

  constructor(poolBorders: PoolBorders, outlineSize: number = 12) {
    this.poolBorders = poolBorders;
    this.outlineSize = outlineSize;

    const assetsMgr = AssetManager.getInstance();

    this.material = new MeshStandardMaterial({
      color: "#A1A1A1",
      toneMapped: true,
      envMapIntensity: 0.1,
      map: assetsMgr.getAsset("wood_color") as Texture,
      normalMap: assetsMgr.getAsset("wood_normal") as Texture,
      aoMap: assetsMgr.getAsset("wood_ao") as Texture,
      roughnessMap: assetsMgr.getAsset("wood_rough") as Texture,
      metalnessMap:assetsMgr.getAsset("wood_rough") as Texture,
    });

    this.createPlankOutline();
  }

  addToScene(scene: Scene) {
    scene.add(this.woodplankMesh);
  }

  removeFromScene(scene: Scene) {
    scene.remove(this.woodplankMesh);
  }

  resize(scene: Scene) {
    this.removeFromScene(scene);
    this.createPlankOutline();

    this.addToScene(scene);
  }

  private createPlankOutline() {
    this.plankShape = this.createShape();
    const gardenGeometry = new ShapeGeometry(this.plankShape);
    gardenGeometry.computeVertexNormals();

    this.applyPlanarMapping(gardenGeometry, 0.3);

    this.woodplankMesh = new Mesh(gardenGeometry, this.material);
    this.woodplankMesh.receiveShadow = true;
    this.woodplankMesh.castShadow = false;
    this.woodplankMesh.layers.set(2);
    this.woodplankMesh.rotation.x = -Math.PI / 2;
  }

   createShape(): Shape {
    const halfLength =
      this.poolBorders.poolLength / 2 +
      this.poolBorders.margin +
      this.outlineSize;
    const halfWidth =
      this.poolBorders.poolWidth / 2 +
      this.poolBorders.margin +
      this.outlineSize;

    const shape = new Shape([
      new Vector2(-halfLength, -halfWidth),
      new Vector2(halfLength, -halfWidth),
      new Vector2(halfLength, halfWidth),
      new Vector2(-halfLength, halfWidth),
    ]);

    shape.holes.push(this.poolBorders.outerShape);
    return shape;
  }

  

  private applyPlanarMapping(geometry: ShapeGeometry, scale: number) {
    const uvAttribute: number[] = [];
    const positions = geometry.getAttribute("position");

    for (let i = 0; i < positions.count; i++) {
      uvAttribute.push(positions.getX(i) * scale, positions.getY(i) * scale);
    }

    geometry.setAttribute(
      "uv",
      new BufferAttribute(new Float32Array(uvAttribute), 2)
    );

    geometry.setAttribute(
      "uv2",
      new BufferAttribute(new Float32Array(uvAttribute), 2)
    );

   // geometry.computeVertexNormals();
  }

  update(time: number) {
    // this.leavesMaterial.uniforms.time.value = time;
  }
}

export default WoodPlanksOutline;
